<div class="splash-container">

  <div class="logo-section">
    <h1 class="brand-name">Noriko<span>| Sushi & Roll</span></h1>
    <p class="tagline"></p>
  </div>

  <div class="login-card animate-in">

    @if (errorMessage) {
      <div class="icon-header error-icon">
        <mat-icon style="color: #e11d48; transform: scale(1.5);">qr_code_scanner</mat-icon>
      </div>

      <h2 style="margin-top: 10px;">Escaneo Requerido</h2>
      <p style="color: #64748b; margin-bottom: 20px;">{{ errorMessage }}</p>

      @if (isDev) {
        <button (click)="simulateScan()" class="dev-btn" mat-stroked-button style="width: 100%;">
          <mat-icon>developer_mode</mat-icon>
          Simular Escaneo Seguro
        </button>
      }
    } @else {
      <div class="icon-header success-icon">
        <mat-icon>waving_hand</mat-icon>
      </div>

      <h2>¡Bienvenido!</h2>
      <p>Estás conectado a tu mesa. ¿Cómo te llamas?</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tu Nombre</mat-label>
        <input (keyup.enter)="startSession()" [(ngModel)]="tempName" autocomplete="off" matInput
               placeholder="Ej. Juan Pérez">
        <mat-icon matPrefix>person</mat-icon>
      </mat-form-field>

      <button (click)="startSession()"
              [disabled]="!tempName.trim()"
              class="start-btn"
              color="primary"
              mat-flat-button>
        <span>Ver el Menú</span>
      </button>
    }

  </div>
</div>
